import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_DISCUSSION_LOAD,
    ACTION_DISCUSSION_LOAD_BY_ID,

    ACTION_DISCUSSION_SAVE,

    ACTION_DISCUSSION_CREATE,

    ACTION_DISCUSSION_VALIDATE,

    IDiscussionLoadAction,
    IDiscussionLoadByIdAction,
    IDiscussionLoadFailureAction,
    IDiscussionLoadSuccessAction,

    IDiscussionSaveAction,
    IDiscussionSaveSuccessAction,
    IDiscussionSaveFailureAction,

    IDiscussionCreateAction,
    IDiscussionCreateSuccessAction,
    IDiscussionCreateFailureAction,

    IDiscussionValidateAction,
    IDiscussionValidateSuccessAction,
    IDiscussionValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/discussion";
import { discussionsApi } from "../services/discussions";

export const
    getDiscussionsEpic = (action$): Observable<IDiscussionLoadSuccessAction | IDiscussionLoadFailureAction> => {
        return action$
            .ofType(ACTION_DISCUSSION_LOAD)
            .mergeMap((action: IDiscussionLoadAction) => {
                return discussionsApi
                    .getDiscussions(action.projectId)
                    .map(response =>
                        LoadSuccess(response.discussions, undefined, [], response.lookups, undefined)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getDiscussionsByIdEpic = (action$): Observable<IDiscussionLoadSuccessAction | IDiscussionLoadFailureAction> => {
        return action$
            .ofType(ACTION_DISCUSSION_LOAD_BY_ID)
            .mergeMap((action: IDiscussionLoadByIdAction) => {
                return discussionsApi
                    .getDiscussionById(action.id)
                    .map(response =>
                        LoadSuccess(response.discussion, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setDiscussionEpic = (action$): Observable<IDiscussionSaveSuccessAction | IDiscussionSaveFailureAction> => {
        return action$
            .ofType(ACTION_DISCUSSION_SAVE)
            .mergeMap((action: IDiscussionSaveAction) => {
                return discussionsApi
                    .setDiscussion(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.discussion, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createDiscussionEpic = (action$): Observable<IDiscussionCreateSuccessAction | IDiscussionCreateFailureAction> => {
        return action$
            .ofType(ACTION_DISCUSSION_CREATE)
            .mergeMap((action: IDiscussionCreateAction) => {
                return discussionsApi
                    .createDiscussion(action.projectId)
                    .map(response =>
                        CreateSuccess(response.discussion, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateDiscussionEpic = (action$): Observable<IDiscussionValidateSuccessAction | IDiscussionValidateFailureAction> => {
        return action$
            .ofType(ACTION_DISCUSSION_VALIDATE)
            .mergeMap((action: IDiscussionValidateAction) => {
                return discussionsApi
                    .validateDiscussion(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.discussion, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }